<script>
  export default {
    name: 'FabricCard',
    props: {
      childClasses:{
        type: String,
        default: '',
      }
    },
  }
</script>

<template>
  <section class="tw-flex tw-flex-col tw-bg-white tw-p-5 tw-min-h-[1px]">
    <article :class="childClasses">
      <slot />
    </article>
  </section>
</template>
